import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteWebhookMutation = () =>
  useTypedMutation({
    mutationFn: async (id: number) => (await ApiInstance.post(`/webhooks/delete`, { id }, ENV.dealerBaseURL)).data,
    onSuccess: id => {
      const previousData = typedQueryClient.getQueryData(WebhooksQueryKeys.webhooks);
      if (!previousData) return;

      const webhookIdx = previousData.findIndex(webhook => webhook.id === id);
      if (webhookIdx === -1) return;

      typedQueryClient.setQueryData(WebhooksQueryKeys.webhooks, [...previousData.toSpliced(webhookIdx, 1)]);
    }
  });
